import React from "react";
import { useLocation } from "react-router-dom";
import SiteNavbar from "./cms/SiteNavbar";
import AdminNavbar from "./components/home/AdminNavbar";
import SiteFooter from "./cms/SiteFooter";
import { useAuth } from "./Authcontext.jsx";

export default function Layout({ children }) {
  const location = useLocation();
  const { profile } = useAuth();

  const hideChrome =
    location.pathname.toLowerCase() === "/login" ||
    location.pathname === "/" ||
    location.pathname.toLowerCase() === "/auth/singpass/callback";

  const isAdmin = profile?.role === "admin";

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {!hideChrome && (
        isAdmin ? <AdminNavbar /> : <SiteNavbar />
      )}

      <main className="flex-1">
        {children}
      </main>

      {!hideChrome && !isAdmin && <SiteFooter />}
    </div>
  );
}